<template>
  <div class="footer">
    <div class="container">
      <div class="left">
        <div class="urls">
          <div class="title">关于公司</div>
          <div>
            <ul>
              <li><a target="_blank" href="https://www.gd-linux.com/">公司简介</a></li>
              <li><a target="_blank" href="http://www.gd-linux.com/html/about/superiority/">优势资源</a></li>
              <li><a target="_blank" href="http://www.gd-linux.com/html/about/recruitment/">人才招聘</a></li>
              <li><a target="_blank" href="http://www.gd-linux.com/html/about/connection/">联系我们</a></li>
            </ul>
          </div>
        </div>
        <div class="urls">
          <div class="title">软件下载</div>
          <div>
            <ul>
              <li><a target="_blank" href="http://www.gd-linux.com/html/xiazai/desktop/">桌面操作系统</a></li>
              <li><a target="_blank" href="http://www.gd-linux.com/html/xiazai/system/">服务器操作系统</a></li>
              <li><a target="_blank" href="http://www.gd-linux.com/html/xiazai/embe/">嵌入式操作系统</a></li>
              <li><a target="_blank" href="http://www.gd-linux.com/html/xiazai/ha/">高可用集群软件</a></li>
            </ul>
          </div>
        </div>
        <div class="urls">
          <div class="title">技术帮助</div>
          <div>
            <ul>
              <li><a target="_blank" href="http://www.gd-linux.com/html/help/">帮助文件</a></li>
              <li><a target="_blank" href="https://121.8.166.38:20443/sn_manager/">在线注册</a></li>
              <li><a target="_blank" href="http://www.gd-linux.com/html/news/company/357.html">用户须知</a></li>
              <li><a target="_blank" href="http://www.gd-linux.com/html/news/company/427.html">产品周期</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="contact">
          <div class="slogan">
            <div>全国7x24小时全天</div>
            <div>为您解决问题</div>
          </div>
          <div class="phone">
            <div>客服电话：400-033-0108</div>
            <div>业务电话：1251111111</div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="code">
          <el-image class="img" :src="newstart_code"></el-image>
          <span>官方微信公众号</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import newstart_code from "@/assets/newstart_code.png";
export default {
  name: "",
  props: [""],
  data() {
    return { newstart_code };
  },

  created() {},

  methods: {},
};
</script>
<style lang='scss' scoped>
@import "../style/index.scss";
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue